import { cloneElement, FunctionComponent, ReactNode } from "react";
import { FieldPipe } from "@animech/axiom-ui-builder";
import * as Styled from "./configuration-panel.style";
import { useUiData } from "src/ui";
import { isReactElementOfType } from "src/utility";
// import { UnitSystemToggle } from "src/ui/components/widgets";

/**
 * FieldPipe keys itself on `activeProperty`, so everything inside the pipe
 * remounts whenever the active property changes. Re-keying the root pipe on
 * the property it actually references gives it a stable identity instead.
 *
 * This clones rather than assigning `slotNode.key`: React freezes elements in
 * its development build, so the assignment silently does nothing there (and
 * throws under the strict-mode bundle), and React 19 turns `key` into a getter,
 * which takes the production path with it.
 */
function withStablePipeKey(slotNode: ReactNode): ReactNode {
	if (!isReactElementOfType(slotNode, FieldPipe)) {
		return slotNode;
	}
	return cloneElement(slotNode, { key: `${slotNode.props.property}` });
}

export const ConfigurationPanel: FunctionComponent = () => {
	const { renderUiSlot } = useUiData();
	const slotNode = withStablePipeKey(renderUiSlot("configurator"));

	return (
		<Styled.Root>
			{slotNode}
			{/* <UnitSystemToggle /> */}
		</Styled.Root>
	);
};
